import React, { useCallback } from 'react';
import { Popover } from '@mantine/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/sharp-solid-svg-icons/faQuestionCircle';

import { CommonPopover } from '@shipstation/client-common/components/common-popover';

import { useToggle } from 'ui-components/hooks/use-toggle';
import { useMaxZ } from 'ui-components/hooks/services/use-max-z';

import styles from './style.module.css';
import { WindsorFrameworkPopoverContent } from './windsor-framework-popover-content';

export const WindsorFrameworkPopover = () => {
  const { activate, deactivate, isActivated } = useToggle(false);
  const zIndex = useMaxZ();

  const togglePopover = useCallback(() => (isActivated ? deactivate() : activate()), [isActivated, activate, deactivate]);
  const handleChange = useCallback((isOpen) => (isOpen ? activate() : deactivate()), [activate, deactivate]);

  return (
    <CommonPopover
      classNames={{ dropdown: styles['info-popover-dropdown'], arrow: styles['info-popover-arrow'] }}
      offset={0}
      onChange={handleChange}
      opened={isActivated}
      position='top'
      shadow='none'
      withArrow
      zIndex={zIndex}
    >
      <Popover.Target>
        <div className={styles['popover-toggle']} onClick={togglePopover}>
          <FontAwesomeIcon className={styles['popover-toggle-icon']} icon={faQuestionCircle} />
        </div>
      </Popover.Target>
      <Popover.Dropdown>
        <WindsorFrameworkPopoverContent />
      </Popover.Dropdown>
    </CommonPopover>
  );
};
